import { useContext } from 'react';

import { CreateMultipleTasksDialogContext } from './create-multiple-tasks-dialog-context';

export const useCreateMultipleTasksDialog = () => {
  const { onOpenDialog } = useContext(CreateMultipleTasksDialogContext);
  return onOpenDialog;
};
